<template>
  <div class="pie-container">
    <div ref="myPie" class="pie"></div>
  </div>
</template>

<script>

// dashboard_pie_kong_xian: 空闲// dashboard_pie_yun_xing_zhong: 运行中// dashboard_pie_chong_dian_zhong: 充电中// dashboard_pie_li_xian: 离线// dashboard_pie_gu_zhang: 故障

export default {
  name: 'pie',
  props: {
    pieData: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {};
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_dashboard_pie');
    this.drawPie();
  },
  methods: {
    drawPie() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(this.$refs.myPie);
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.pieData.total,
          left: 'center',
          top: 'center',
        },
        tooltip: {
          trigger: 'none',
        },
        series: [
          {
            name: 'title',
            type: 'pie',
            radius: ['66%', '82%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 1,
            },
            label: {
              show: false,
              position: 'inner',
            },
            // hover显示文字样式，设置后，tooltip关闭无效
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold',
              },
              scale: false,
            },
            data: !this.pieData.idle && !this.pieData.using && !this.pieData.charging && !this.pieData.offline ? [] : [
              { value: this.pieData.idle, name: this.$t('dashboard_pie_kong_xian'), itemStyle: { color: '#00a0d9' } },
              { value: this.pieData.using, name: this.$t('dashboard_pie_yun_xing_zhong'), itemStyle: { color: '#93da49' } },
              { value: this.pieData.charging, name: this.$t('dashboard_pie_chong_dian_zhong'), itemStyle: { color: '#ffad00' } },
              { value: this.pieData.offline, name: this.$t('dashboard_pie_li_xian'), itemStyle: { color: '#b3b3b3' } },
            ],
          },
          {
            type: 'pie',
            radius: ['50%', '66%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 1,
            },
            label: {
              show: false,
              position: 'inner',
            },
            // hover显示文字样式，设置后，tooltip关闭无效
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold',
              },
              scale: false,
            },
            data: !this.pieData.malfunction && !this.pieData.total ? [] : [
              { value: this.pieData.malfunction, name: this.$t('dashboard_pie_gu_zhang'), itemStyle: { color: '#EB5A5A' } },
              { value: this.pieData.total, name: '', itemStyle: { color: '#F8F9FA' } },
            ],
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss">
.pie-container {
  width: 100%;
  height: 100%;
  position: relative;
  .pie {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
}
</style>
